import { render } from "./pay_for_b_a.vue?vue&type=template&id=9f661450&scoped=true"
import script from "./pay_for_b_a.vue?vue&type=script&lang=js"
export * from "./pay_for_b_a.vue?vue&type=script&lang=js"

import "./pay_for_b_a.vue?vue&type=style&index=0&id=9f661450&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f661450"]])

export default __exports__